import { Instance, getRoot } from 'mobx-state-tree'
import dayjs, { Dayjs } from 'dayjs'

import { AnnouncementResponseModelBase } from './AnnouncementResponseModel.base'
import { AnnouncementStatsResponseModelType } from './AnnouncementStatsResponseModel'

/* The TypeScript type of an instance of AnnouncementResponseModel */
export interface AnnouncementResponseModelType
  extends Instance<typeof AnnouncementResponseModel.Type> {}

/* A graphql query fragment builders for AnnouncementResponseModel */
export {
  selectFromAnnouncementResponse,
  announcementResponseModelPrimitives,
  AnnouncementResponseModelSelector
} from './AnnouncementResponseModel.base'

/**
 * AnnouncementResponseModel
 */
export const AnnouncementResponseModel = AnnouncementResponseModelBase.actions(
  self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  })
)
  .views(self => ({
    get $publishStart() {
      return dayjs(self.publishStart)
    },
    get $publishEnd() {
      return dayjs(self.publishEnd)
    },
    get $createdAt() {
      return dayjs(self.createdAt)
    },
    get $stats() {
      return self.stats as AnnouncementStatsResponseModelType[] | undefined
    }
  }))
  .views(self => ({
    get readPercentage() {
      return Math.round(
        ((self.$stats?.filter(s => s.readTimestamp).length || 0) /
          (self.$stats?.length || 0)) *
          100
      )
    }
  }))
  .actions(self => ({
    setSubject(newSubject: string) {
      self.subject = newSubject
    },
    setBodyText(newBodyText: string) {
      self.body = newBodyText
    },
    setPublishStart(newPublishStart: Dayjs) {
      self.publishStart = newPublishStart.toISOString()
    },
    setPublishEnd(newPublishEnd: Dayjs) {
      self.publishEnd = newPublishEnd.toISOString()
    },
    togglePriority() {
      self.highPriority = !self.highPriority
    },
    toggleNotify() {
      self.sendAlert = !self.sendAlert
    },
    setAsRead() {
      const loggedInUserId: string = (getRoot(self) as any).loggedInUser.id
      const personStat = self.$stats?.find(
        s => s.$person._id === loggedInUserId
      )

      if (personStat) personStat.readTimestamp = new Date()
    }
  }))
